"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import { cx } from "@/lib/tailwind-utils";
import { PhoneAuthStep, usePhoneAuthOptional } from "./methods/phone/phone-auth-context";
export interface AuthShellProps {
  logo?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  /** Content rendered inside the card, below children. */
  footer?: ReactNode;
  /** Small muted line rendered *below* the card (e.g. "Securing access to X"). */
  tagline?: ReactNode;
  children: ReactNode;
  className?: string;
}
export function AuthShell(t0) {
  const $ = _c(24);
  const {
    logo,
    title,
    description,
    footer,
    tagline,
    children,
    className
  } = t0;
  const phone = usePhoneAuthOptional();
  const isWide = phone?.state.step === PhoneAuthStep.ENTER_PHONE;
  const t1 = isWide ? "max-w-3xl" : "max-w-md";
  let t2;
  if ($[0] !== t1) {
    t2 = cx("mb-8 w-full transition-[max-width] duration-200", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = cx("relative overflow-hidden", "bg-background/40 shadow-xl backdrop-blur-sm", "transition-all duration-500 ease-out", "max-h-[90dvh] overflow-y-auto", "rounded-3xl", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="pointer-events-none absolute inset-0 rounded-3xl shadow-inner" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== description || $[6] !== logo || $[7] !== title) {
    t5 = (logo || title || description) && <div className="flex flex-col items-center">{logo && <div className="mb-4">{logo}</div>}{title && <h3 className="mb-1 text-center text-h3 text-foreground">{title}</h3>}{description && <p className="text-center text-body text-foreground-secondary">{description}</p>}</div>;
    $[5] = description;
    $[6] = logo;
    $[7] = title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== footer) {
    t6 = footer && <div className="mt-4 sm:mt-6">{footer}</div>;
    $[9] = footer;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== t5 || $[13] !== t6) {
    t7 = <div className="relative px-6 py-8 md:px-8 md:py-10">{t5}{children}{t6}</div>;
    $[11] = children;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t7) {
    t8 = <div className={t3}>{t4}{t7}</div>;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== tagline) {
    t9 = tagline && <p className="mt-4 text-center text-caption text-foreground-muted">{tagline}</p>;
    $[18] = tagline;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t2 || $[21] !== t8 || $[22] !== t9) {
    t10 = <div className="fixed inset-0 flex items-center justify-center overflow-hidden px-4 lg:px-6"><div className={t2}>{t8}{t9}</div></div>;
    $[20] = t2;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}